<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <div>
          <div>
            <h6 class="heading-small text-muted mb-4">Template</h6>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="selectedAccountReportTemplateId"
                  style="width: 100%"
                  placeholder="Select Template"
                  :filter-option="filterOption"
                  @change="
                    (event) => {
                      setAccountReportTemplate(event);
                      setOrigConfig(event);
                    }
                  "
                >
                  <a-select-option
                    v-for="template in options.accountReportTemplates"
                    :value="template.id"
                    :key="template.id"
                    :label="template.name"
                  >
                    {{ template.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </div>
        <br />
        <form role="form" @submit.prevent>
          <h6 class="heading-small text-muted mb-4">Filters</h6>
          <div>
            <div>
              <label>Membership Program</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.membership_programs"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Membership Programs"
                >
                  <a-select-option
                    v-for="membership_program in options.membership_programs"
                    :key="membership_program.id"
                    :value="membership_program.id"
                    :label="membership_program.name"
                  >
                    {{ membership_program.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Membership Level</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.membership_levels"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Membership Level"
                >
                  <a-select-option
                    v-for="opt in options.membership_levels"
                    :value="opt.id"
                    :key="opt.id"
                    :label="opt.name"
                  >
                    {{ opt.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Membership Tags</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.member_tags"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Member Tags"
                >
                  <a-select-option value="[BLANK]"> [blank] </a-select-option>
                  <a-select-option
                    v-for="opt in options.member_tags"
                    :value="opt.id"
                    :key="opt.id"
                    :label="opt.name"
                  >
                    {{ opt.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <!-- <div>
            <div>
              <label>Customer Type</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.customer_types"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Customer Type"
                >
                  <a-select-option value="[BLANK]"> [blank] </a-select-option>
                  <a-select-option
                    v-for="opt in options.customer_types"
                    :value="opt.id"
                    :key="opt.id"
                    :label="opt.name"
                  >
                    {{ opt.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div> -->
          <div>
            <div>
              <label>Member Status</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.member_statuses"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Member Status"
                >
                  <a-select-option
                    v-for="opt in options.member_statuses"
                    :value="opt.id"
                    :key="opt.id"
                    :label="opt.name"
                  >
                    {{ opt.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Site</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.site_ids"
                  mode="multiple"
                  style="width: 100%"
                  placeholder="Select Sites"
                  :filter-option="filterOption"
                >
                  <a-select-option value="[BLANK]"> [blank] </a-select-option>
                  <a-select-option
                    v-for="site in options.sites"
                    :value="site.id"
                    :key="site.id"
                    :label="site.name"
                  >
                    {{ site.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Site Concept</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.site_concepts"
                  style="width: 100%"
                  mode="multiple"
                  :filter-option="filterOption"
                  placeholder="Select Site Concept"
                >
                  <a-select-option
                    v-for="siteConcept in options.siteConcepts"
                    :value="siteConcept.id"
                    :key="siteConcept.id"
                    :label="siteConcept.name"
                  >
                    {{ siteConcept.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Company</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.companies"
                  style="width: 100%"
                  mode="multiple"
                  :filter-option="filterOption"
                  placeholder="Select Companies"
                >
                  <a-select-option
                    v-for="company in options.companies"
                    :value="company.id"
                    :key="company.id"
                    :label="company.name"
                  >
                    {{ company.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Member Expiration Date</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-range-picker
                    v-model="dateRange.expirationDateRange"
                    :default-value="[
                      table.appendedParams.expired_date_from,
                      table.appendedParams.expired_date_to
                    ]"
                    :format="dateFormat"
                    @change="handleExpirationDateRangeChange"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Date Registered (From - To)</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-range-picker
                    v-model="dateRange.memberRegistrationDateRange"
                    :default-value="[
                      table.appendedParams.date_from,
                      table.appendedParams.date_to
                    ]"
                    :format="dateFormat"
                    @change="handleMemberRegistrationDateChange"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <!-- <div>
            <div>
              <label>Mobile Registration Date</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-range-picker
                    v-model="dateRange.mobileRegistrationDateRange"
                    :default-value="[
                      table.appendedParams.mobile_registration_from,
                      table.appendedParams.mobile_registration_to
                    ]"
                    :format="dateFormat"
                    @change="handleMobileRegistrationDateRangeChange"
                  />
                </base-input>
              </div>
            </div>
          </div> -->
          <!-- <div>
            <div>
              <label>Latest Transaction Date</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-range-picker
                    v-model="dateRange.transactionDateRange"
                    :default-value="[
                      table.appendedParams.transaction_date_from,
                      table.appendedParams.transaction_date_to
                    ]"
                    :format="dateFormat"
                    @change="handleTransactionDateRangeChange"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Latest Renewal Date</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-range-picker
                    v-model="dateRange.renewalDateRange"
                    :default-value="[
                      table.appendedParams.renewal_date_from,
                      table.appendedParams.renewal_date_to
                    ]"
                    :format="dateFormat"
                    @change="handleRenewalDateRangeChange"
                  />
                </base-input>
              </div>
            </div>
          </div> -->
          <div class="row">
            <div class="col">
              <base-button
                type="primary btn-block"
                class="my-4"
                @click.prevent="applyFilter"
              >
                <div>Apply Filter</div>
              </base-button>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.appendedParams"
          :sortOrder="table.sortOrder"
          :sortParams="getSortParam"
          :multiSort="table.multiSort"
          :multiSortKey="table.multiSortKey"
        >
          <template #headerButtons>
            <div>
              <b-button
                v-if="selectedActions.includes('Customize')"
                variant="primary"
                @click.prevent="openDrawer('report_template')"
                >Customize
              </b-button>
              <b-button
                v-if="
                  selectedActions.includes('Download') ||
                  selectedActions.includes('Send')
                "
                variant="danger"
                @click.prevent="openDrawer('export_data')"
                >Export
              </b-button>
            </div>
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <AccountReportTemplate
                v-if="drawer.action == 'report_template'"
                :accountReport="accountReport"
                :accountReportTemplate="accountReportTemplate"
                :selectedAccountReportTemplateColumns="tableFields"
                :selectedAccountReportTemplateFilters="table.appendedParams"
                :selectedAccountReportTemplateSorts="table.sortOrder"
                :updatedFilter="updatedFilters"
                @setTableColumns="setTableColumns"
                @setAccountReportTemplate="getAccountReportData"
                @deleteAccountReportTemplate="getAccountReportData"
                @closeDrawer="closeDrawer"
                @setUpdatedFilter="updatedFilters = false"
              />

              <ExportDataForm
                v-if="drawer.action == 'export_data'"
                :template="selectedAccountReportTemplateId"
                :jsonFields="toJsonFields"
                :filename="filename"
                :apiUrl="tableApiUrl"
                @closeDrawer="closeDrawer"
                :type="fileType"
              />
            </a-drawer>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import HTTPRequest from '../../../controllers/httpRequest';
import PageHeader from '../../../components/Page/Header.vue';
import PageContent from '../../../components/Page/Content.vue';
import PageTable from '../../../components/Page/Table.vue';
import AccountReportTemplate from '../Drawers/AccountReportTemplateForm.vue';
import ExportDataForm from '../Drawers/ExportDataForm.vue';
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
import secureStorage from '@/controllers/secureStorage';

// const APP_ENV = process.env.VUE_APP_ENV;
// const TIMEZONE = process.env.VUE_APP_TIMEZONE || 'Asia/Singapore';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    AccountReportTemplate,
    ExportDataForm
  },
  data() {
    return {
      fileType: 'xls',
      filename: `Report - ${moment().format('YYYY-MM-DDTHHmmss.SSS')}.xls`,
      updatedFilters: false,
      originalFilter: null,
      gradientType: 'gradient-yellow',
      accountReport: null,
      dateFormat: 'YYYY-MM-DD',
      accountReportTemplate: null,
      selectedAccountReportTemplateId: null,
      saveFilters: false,
      saveSorts: false,
      drawer: {
        visible: false,
        width: 600,
        placement: 'right',
        action: null
      },
      dateRange: {
        mobileRegistrationDateRange: [null, null],
        expirationDateRange: [null, null],
        memberRegistrationDateRange: [
          moment().format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        transactionDateRange: [null, null],
        renewalDateRange: [null, null]
      },

      table: {
        title: 'Customer Information Reports',
        apiUrl:
          '/api/v1/reports/customers_info?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        fields: [],
        appendedParams: {
          version: 'v1',
          membership_programs: [],
          membership_levels: [],
          customer_types: [],
          site_ids: [],
          site_concepts: [],
          companies: [],
          member_statuses: [],
          member_tags: [],

          date_from: moment().format('YYYY-MM-DD'),
          date_to: moment().format('YYYY-MM-DD'),
          expired_date_from: null,
          expired_date_to: null,
          mobile_registration_from: null,
          mobile_registration_to: null,
          transaction_date_from: null,
          transaction_date_to: null,
          renewal_date_from: null,
          renewal_date_to: null,

          report_type: 'list',
          export_data: false,
          filter: false
        },
        multiSort: true,
        multiSortKey: 'alt',
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ]
      },
      options: {
        member_statuses: [],
        membership_programs: [],
        member_tags: [],
        membership_levels: [],
        customer_types: [],
        reportTypes: [{ id: 'list', name: 'Listing' }],
        reportTemplates: [],
        sites: [],
        siteConcepts: [],
        companies: [],
        accountReportTemplates: null
      }
    };
  },
  methods: {
    filterOption(inputValue, option) {
      let str = option?.componentOptions?.propsData?.label ?? '';
      return str.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1;
    },
    async getFilters() {
      const resp = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs',
        { per_page: 1000 }
      );
      this.options.membership_programs = resp.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      const memberStatuses = await HTTPRequest.getRequest(
        '/api/v1/clp_member_statuses',
        { per_page: 1000, status_code: 'A' }
      );
      this.options.member_statuses = memberStatuses.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );

      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_levels`,
        { per_page: 1000 }
      );
      this.options.membership_levels = data.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );

      const customerTypes = await HTTPRequest.getRequest(
        `/api/v1/customer_types`,
        { per_page: 1000, status_code: 'A' }
      );
      this.options.customer_types = customerTypes.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    isValidJSON(jsonString) {
      try {
        JSON.parse(jsonString);
        return true;
      } catch (error) {
        return false;
      }
    },
    async getSiteConcepts() {
      const response = await HTTPRequest.getRequest('/api/v1/site_concepts', {
        per_page: 1000
      });
      this.options.siteConcepts = response.data;
    },

    async getCompanies() {
      const response = await HTTPRequest.getRequest('/api/v1/companies', {
        per_page: 1000
      });
      this.options.companies = response.data;
    },
    async getMemberTags() {
      const response = await HTTPRequest.getRequest('/api/v1/clp_member_tags', {
        per_page: 10000
      });
      this.options.member_tags = response.data;
    },

    async getAccountReportData() {
      let accountReport = await HTTPRequest.getRequest(
        '/api/v1/account_reports/CUSTOMER_INFO_REPORTS_LIST/default'
      );
      this.accountReport = accountReport;
      await this.setAccountReportTemplate(
        accountReport.accountReportTemplates[0]
      );
      this.setOrigConfig(accountReport.accountReportTemplates[0]);
      await this.getAccountReportTemplates();
    },
    async getAccountReportTemplates() {
      const data = await HTTPRequest.getRequest(
        '/api/v1/account_report_templates/' +
          this.accountReport.code +
          '/templates'
      );
      this.options.accountReportTemplates = data;
    },

    async getSites() {
      // Refactoring code for getting sites
      // const defaultSite = secureStorage.getItem('defaultSite');
      // if (this.inHeadOffice) {
      //   this.options.sites = secureStorage.getItem('visitingSites');
      // } else {
      //   this.options.sites = [secureStorage.getItem('currentSite')];
      // }
      // this.table.appendedParams.site_ids.push(defaultSite.id);

      const response = await HTTPRequest.getRequest('/api/v1/sites', {
        per_page: 1000
      });
      this.options.sites = response.data;
    },

    setAccountReportTemplate(accountReportTemplate) {
      let accountReportTemplateData;
      if (typeof accountReportTemplate == 'number') {
        this.selectedAccountReportTemplateId = accountReportTemplate;
        for (const template of this.options.accountReportTemplates) {
          if (accountReportTemplate == template.id) {
            this.accountReportTemplate = template;
            accountReportTemplateData = JSON.parse(template.config);
          }
        }
      } else {
        this.accountReportTemplate = accountReportTemplate;
        accountReportTemplateData = JSON.parse(accountReportTemplate.config);
        this.selectedAccountReportTemplateId = accountReportTemplate.id;
      }

      /** Clear the previous' template's filter/s */
      this.clearTableFilters();

      /** Clear the previous' template's sort/s */
      this.clearTableSorts();

      /** Load template's default columns */
      this.setTableColumns(accountReportTemplateData.columns);

      if (
        accountReportTemplateData.filters &&
        Object.keys(accountReportTemplateData.filters).includes('source')
      ) {
        const spreadFilter = { ...accountReportTemplateData.filters };
        delete spreadFilter['source'];
        accountReportTemplateData.filters = spreadFilter;
      }
      /** Load template's default filters */
      this.setTableFilters(accountReportTemplateData.filters);

      /** Load template's default sort */
      this.setTableSorts(accountReportTemplateData.sorts);
    },

    async setTableColumns(columns = []) {
      /**
       * Note: Amongst the other 2 methods on clearing the table fields,
       * this one worked as this doesn't alter the original array instance
       *
       * this.table.fields = this.table.fields.splice(0, this.table.fields.length);
       * this.table.fields = [];
       * */
      /** Clear table fields */
      this.table.fields.length = 0;
      const that = this;
      const tableFields = this.table.fields;
      const response = await HTTPRequest.getRequest('/api/v1/clp_member_tags', {
        per_page: 10000
      });
      const memberTags = response.data;

      columns.forEach((column) => {
        /** Check if current "column" is already in the table */ ``;
        let hasField = tableFields.find((field) => field.name === column.name);
        if (typeof hasField === 'undefined') {
          if (Object.keys(column).includes('value')) {
            if (column.value) {
              switch (column.name) {
                case 'member_tags':
                  column.formatter = function (member_tags) {
                    if (that.isValidJSON(member_tags)) {
                      const memberTagsSplit =
                        member_tags != null ? JSON.parse(member_tags) : null;
                      if (
                        memberTagsSplit &&
                        typeof memberTagsSplit == 'object'
                      ) {
                        let resp = '';
                        for (let i = 0; i < memberTagsSplit.length; i++) {
                          for (let x = 0; x < memberTags.length; x++) {
                            if (memberTags[x].id == memberTagsSplit[i]) {
                              resp += memberTags[x].name + ' <br>';
                              break;
                            }
                          }
                        }
                        return resp;
                      } else {
                        return member_tags;
                      }
                    }
                  };
                  break;
                case 'current_points_balance_active':
                  column.formatter = function (points) {
                    return points
                      ? Number(points).toLocaleString('en-US', {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        })
                      : 0;
                  };
                  break;
                case 'current_points_balance_expiring':
                  column.formatter = function (points) {
                    return points
                      ? Number(points).toLocaleString('en-US', {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        })
                      : 0;
                  };
                  break;
                case 'total_purchase':
                  column.formatter = function (amount) {
                    return amount
                      ? Number(amount).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })
                      : 0.0;
                  };
                  break;
                case 'birth_day':
                  column.formatter = function (bdate) {
                    return bdate ? moment(bdate).format('MM-YYYY') : null;
                  };
                  break;
                case 'mobile_registration_date':
                case 'renewal_date':
                case 'created_at':
                  column.formatter = function (date) {
                    if (date !== null) {
                      let d = date.replace('Z', '');
                      if (moment(d).isValid()) {
                        return moment(d).format('YYYY-MM-DD h:mm A');
                      }
                    }
                    return null;
                  };
                  break;
                case 'member_expired_at':
                case 'latest_transaction_date':
                  column.formatter = function (date) {
                    if (moment(date).isValid()) {
                      return moment(date).format('YYYY-MM-DD h:mm A');
                    }
                    return null;
                  };
                  break;
                case 'is_migrated':
                  column.formatter = function (value) {
                    return value ? 'Yes' : 'No';
                  };
                  break;
                case 'total_points':
                case 'total_expired_points':
                  column.formatter = function (points) {
                    return points
                      ? Number(points).toLocaleString('en-US', {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        })
                      : 0;
                  };
                  break;
              }
              this.table.fields.push(column);
            }
          } else {
            switch (column.name) {
              case 'member_tags':
                column.formatter = function (member_tags) {
                  if (that.isValidJSON(member_tags)) {
                    const memberTagsSplit =
                      member_tags != null ? JSON.parse(member_tags) : null;
                    if (memberTagsSplit && typeof memberTagsSplit == 'object') {
                      let resp = '';
                      for (let i = 0; i < memberTagsSplit.length; i++) {
                        for (let x = 0; x < memberTags.length; x++) {
                          if (memberTags[x].id == memberTagsSplit[i]) {
                            resp += memberTags[x].name + ' <br>';
                            break;
                          }
                        }
                      }
                      return resp;
                    } else {
                      return member_tags;
                    }
                  }
                };
                break;
              case 'current_points_balance_active':
                column.formatter = function (points) {
                  return points
                    ? Number(points).toLocaleString('en-US', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      })
                    : 0;
                };
                break;
              case 'current_points_balance_expiring':
                column.formatter = function (points) {
                  return points
                    ? Number(points).toLocaleString('en-US', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      })
                    : 0;
                };
                break;
              case 'total_purchase':
                column.formatter = function (amount) {
                  return amount
                    ? Number(amount).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })
                    : 0.0;
                };
                break;
              case 'birth_day':
                column.formatter = function (bdate) {
                  return bdate ? moment(bdate).format('MM-YYYY') : null;
                };
                break;
              case 'mobile_registration_date':
              case 'renewal_date':
              case 'created_at':
                column.formatter = function (date) {
                  if (date !== null) {
                    let d = date.replace('Z', '');
                    if (moment(d).isValid()) {
                      return moment(d).format('YYYY-MM-DD h:mm A');
                    }
                  }
                  return null;
                };
                break;
              case 'member_expired_at':
              case 'latest_transaction_date':
                column.formatter = function (date) {
                  if (moment(date).isValid()) {
                    return moment(date).format('YYYY-MM-DD h:mm A');
                  }
                  return null;
                };
                break;
              case 'is_migrated':
                column.formatter = function (value) {
                  return value ? 'Yes' : 'No';
                };
                break;
              case 'total_points':
              case 'total_expired_points':
                column.formatter = function (points) {
                  return points
                    ? Number(points).toLocaleString('en-US', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      })
                    : 0;
                };
                break;
            }
            this.table.fields.push(column);
          }
        }
      });
    },

    setTableFilters(filters = {}) {
      if (Object.keys(filters).length !== 0) {
        this.table.appendedParams = filters;
      }
    },

    setTableSorts(sorts = []) {
      if (sorts && sorts.length > 0) {
        this.table.sortOrder = sorts;
      } else {
        this.table.sortOrder = sorts;
      }
    },

    getSortParam(sortOrder) {
      return sortOrder
        .map(function (sort) {
          return sort.field + '|' + sort.direction;
        })
        .join(',');
    },

    async onChangeReportType() {
      this.reloadTbl = false;
      /** Get report data for the report type */
      await this.getAccountReportData();

      /** Clear filters for the table */
      this.clearTableFilters();

      /** Reload table */
      this.applyFilter();
    },

    clearTableFilters() {
      this.table.appendedParams.membership_programs = [];
      this.table.appendedParams.membership_levels = [];
      this.table.appendedParams.site_ids = [];
      this.table.appendedParams.member_statuses = [];
      this.table.appendedParams.member_tags = [];

      this.dateRange.memberRegistrationDateRange = [
        moment().format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD')
      ];
      this.table.appendedParams.date_from = moment().format('YYYY-MM-DD');
      this.table.appendedParams.date_to = moment().format('YYYY-MM-DD');

      this.dateRange.expirationDateRange = [null, null];
      this.table.appendedParams.expired_date_from = null;
      this.table.appendedParams.expired_date_to = null;

      this.dateRange.mobileRegistrationDateRange = [null, null];
      this.table.appendedParams.mobile_registration_from = null;
      this.table.appendedParams.mobile_registration_to = null;

      this.dateRange.transactionDateRange = [null, null];
      this.table.appendedParams.transaction_date_from = null;
      this.table.appendedParams.transaction_date_to = null;

      this.dateRange.renewalDateRange = [null, null];
      this.table.appendedParams.renewal_date_from = null;
      this.table.appendedParams.renewal_date_to = null;
    },

    clearTableSorts() {
      this.table.sortOrder = [
        {
          field: 'id',
          direction: 'desc'
        }
      ];
    },

    openDrawer(action) {
      this.drawer.visible = true;
      this.drawer.action = action;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.drawer.action = null;
    },

    applyFilter() {
      this.reloadTbl = true;
      this.table.appendedParams.filter = true;
      this.table.appendedParams.template = this.selectedAccountReportTemplateId;
      this.setFilter();
    },

    setFilter() {
      this.table.appendedParams.filter = true;
      this.originalFilter === JSON.stringify(this.table.appendedParams)
        ? (this.updatedFilters = false)
        : (this.updatedFilters = true);

      this.setMemberRegistrationDateRangeFilter();

      this.setMobileRegistrationDateRangeFilter();

      this.setRenewalDateRangeFilter();

      this.setTransactionDateRangeFilter();

      this.setExpirationDateRangeFilter();

      this.$root.$emit('refreshTable');
    },

    handleMobileRegistrationDateRangeChange(dateObj, dateString) {
      this.table.appendedParams.mobile_registration_from = dateString[0];
      this.table.appendedParams.mobile_registration_to = dateString[1];
      this.dateRange.mobileRegistrationDateRange = [
        dateString[0],
        dateString[1]
      ];
    },

    handleRenewalDateRangeChange(dateObj, dateString) {
      this.table.appendedParams.renewal_date_from = dateString[0];
      this.table.appendedParams.renewal_date_to = dateString[1];
      this.dateRange.renewalDateRange = [dateString[0], dateString[1]];
    },

    handleTransactionDateRangeChange(dateObj, dateString) {
      this.table.appendedParams.transaction_date_from = dateString[0];
      this.table.appendedParams.transaction_date_to = dateString[1];
      this.dateRange.transactionDateRange = [dateString[0], dateString[1]];
    },

    handleExpirationDateRangeChange(dateObj, dateString) {
      this.table.appendedParams.expired_date_from = dateString[0];
      this.table.appendedParams.expired_date_to = dateString[1];
      this.dateRange.expirationDateRange = [dateString[0], dateString[1]];
    },

    handleMemberRegistrationDateChange(dateObj, dateString) {
      this.table.appendedParams.date_from = dateString[0];
      this.table.appendedParams.date_to = dateString[1];
      this.dateRange.memberRegistrationDateRange = [
        dateString[0],
        dateString[1]
      ];
    },

    serializeQuery(params, prefix) {
      const query = Object.keys(params).map((key) => {
        if (params[key]) {
          const value = params[key];

          if (params.constructor === Array) {
            key = `${prefix}[]`;
          } else if (params.constructor === Object) {
            key = prefix ? `${prefix}[${key}]` : key;
          }

          if (typeof value === 'object') {
            return this.serializeQuery(value, key);
          } else {
            return `${key}=${encodeURIComponent(value)}`;
          }
        }
      });

      let serializedQuery = query.filter((elem) => elem != '');

      return [].concat.apply([], serializedQuery).join('&');
    },

    setOrigConfig(event) {
      if (typeof event == 'number') {
        for (const template of this.options.accountReportTemplates) {
          if (event == template.id) {
            const jConfig = JSON.parse(template.config);
            if (Object.keys(jConfig).includes('filter')) {
              this.originalFilter = JSON.stringify(
                JSON.parse(jConfig.config).filters
              );
            } else {
              this.originalFilter = JSON.stringify(this.table.appendedParams);
            }
          }
        }
      } else {
        const jConfig = JSON.parse(event.config);
        if (Object.keys(jConfig).includes('filter')) {
          this.originalFilter = JSON.stringify(jConfig.filters);
        } else {
          this.originalFilter = JSON.stringify(this.table.appendedParams);
        }
      }
    },

    setMemberRegistrationDateRangeFilter() {
      const memberRegistrationDateRange =
        this.dateRange.memberRegistrationDateRange;
      if (
        this.table.appendedParams.date_from != '' &&
        this.table.appendedParams.date_from
      ) {
        this.table.appendedParams.date_from = memberRegistrationDateRange[0];
      }

      if (
        this.table.appendedParams.date_to != '' &&
        this.table.appendedParams.date_to
      ) {
        this.table.appendedParams.date_to = memberRegistrationDateRange[1];
      }
    },

    setMobileRegistrationDateRangeFilter() {
      const mobileRegistrationDateRange =
        this.dateRange.mobileRegistrationDateRange;

      if (
        this.table.appendedParams.mobile_registration_from != null &&
        this.table.appendedParams.mobile_registration_from
      ) {
        this.table.appendedParams.mobile_registration_from =
          mobileRegistrationDateRange[0];
      }

      if (
        this.table.appendedParams.mobile_registration_to != null &&
        this.table.appendedParams.mobile_registration_to
      ) {
        this.table.appendedParams.mobile_registration_to =
          mobileRegistrationDateRange[1];
      }
    },

    setRenewalDateRangeFilter() {
      const renewalDateRange = this.dateRange.renewalDateRange;

      if (
        this.table.appendedParams.renewal_date_from != null &&
        this.table.appendedParams.renewal_date_from
      ) {
        this.table.appendedParams.renewal_date_from = renewalDateRange[0];
      }

      if (
        this.table.appendedParams.renewal_date_to != null &&
        this.table.appendedParams.renewal_date_to
      ) {
        this.table.appendedParams.renewal_date_to = renewalDateRange[1];
      }
    },

    setTransactionDateRangeFilter() {
      const transactionDateRange = this.dateRange.transactionDateRange;

      if (
        this.table.appendedParams.transaction_date_from != '' &&
        this.table.appendedParams.transaction_date_from
      ) {
        this.table.appendedParams.transaction_date_from =
          transactionDateRange[0];
      }

      if (
        this.table.appendedParams.transaction_date_to != '' &&
        this.table.appendedParams.transaction_date_to
      ) {
        this.table.appendedParams.transaction_date_to = transactionDateRange[1];
      }
    },

    setExpirationDateRangeFilter() {
      const expirationDateRange = this.dateRange.expirationDateRange;

      if (
        this.table.appendedParams.expired_date_from != '' &&
        this.table.appendedParams.expired_date_from
      ) {
        this.table.appendedParams.expired_date_from = expirationDateRange[0];
      }
      if (
        this.table.appendedParams.expired_date_to != '' &&
        this.table.appendedParams.expired_date_to
      ) {
        this.table.appendedParams.expired_date_to = expirationDateRange[1];
      }
    }
  },
  watch: {
    inHeadOffice: function () {
      if (this.inHeadOffice) {
        this.options.sites = secureStorage.getItem('visitingSites');
      } else {
        this.options.sites = [secureStorage.getItem('currentSite')];
      }
    }
  },
  created() {
    this.getFilters();

    this.getMemberTags();

    this.getSites();

    this.getAccountReportData();

    this.getSiteConcepts();

    this.getCompanies();

    this.$store.dispatch('setCurrentModule', 'CustomerInfoReport');
  },
  mounted() {
    // this.selectedActions = this.$store.getters.getModuleSelectedActions;
  },

  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions',
      headOfficeId: 'getHeadOffice'
    }),
    tableFields() {
      const _tableFields = [...this.table.fields];
      return _tableFields;
    },

    inHeadOffice() {
      return secureStorage.getItem('currentSiteId') == this.headOfficeId
        ? true
        : false;
    },
    tableApiUrl() {
      const tableApiUrl = this.table.apiUrl;
      const _tableParams = { ...this.table.appendedParams };
      _tableParams.export_data = true; // Update to true, for exportable data
      const _tableSort = [...this.table.sortOrder];
      let sorts, filters;

      /** Create query string for "sort" first if there are sorting */
      if (_tableSort.length > 0) {
        let i = 0;
        for (let sort of _tableSort) {
          if (i == 0) {
            sorts = 'sort=' + sort.field + '|' + sort.direction;
          } else {
            sorts += ',' + sort.field + '|' + sort.direction;
          }
          i++;
        }
      }

      /** Parse object for query string */
      filters = this.serializeQuery(_tableParams);
      if (tableApiUrl.includes('?')) {
        return tableApiUrl + '&' + sorts + '&' + filters;
      } else {
        return tableApiUrl + '?' + sorts + '&' + filters;
      }
    },

    toJsonFields: function () {
      const memberTags = this.options.member_tags;
      const _tableFields = [...this.table.fields];
      let jsonFields = {};

      for (let field of _tableFields) {
        jsonFields[field.title] = field.name;
        switch (field.name) {
          case 'member_tags':
            jsonFields[field.title] = {
              field: field.name,
              callback: (member_tags) => {
                if (this.isValidJSON(member_tags)) {
                  const memberTagsSplit =
                    member_tags != null ? JSON.parse(member_tags) : null;
                  if (memberTagsSplit && typeof memberTagsSplit == 'object') {
                    let resp = '';
                    for (let i = 0; i < memberTagsSplit.length; i++) {
                      for (let x = 0; x < memberTags.length; x++) {
                        if (memberTags[x].id == memberTagsSplit[i]) {
                          resp += memberTags[x].name;
                          if (i < memberTagsSplit.length - 1) {
                            resp += ' | ';
                          }
                          break;
                        }
                      }
                    }
                    return resp;
                  } else {
                    return member_tags;
                  }
                }
              }
            };
            break;
          case 'registration_site_code':
          case 'card_number':
            jsonFields[field.title] = {
              field: field.name,
              callback: (value) => {
                return '="' + value + '"';
              }
            };
            break;
          case 'birth_day':
            jsonFields[field.title] = {
              field: field.name,
              callback: (value) => {
                return value ? moment(value).format('MM-YYYY') : null;
              }
            };
            break;
          case 'mobile_registration_date':
          case 'renewal_date':
          case 'created_at':
            jsonFields[field.title] = {
              field: field.name,
              callback: (date) => {
                if (date !== null) {
                  let d = date.replace('Z', '');
                  if (moment(d).isValid()) {
                    return moment(d).format('YYYY-MM-DD h:mm A');
                  }
                }
                return null;
              }
            };
            break;
          case 'member_expired_at':
          case 'latest_transaction_date':
            jsonFields[field.title] = {
              field: field.name,
              callback: (date) => {
                if (moment(date).isValid()) {
                  return moment(date).format('YYYY-MM-DD h:mm A');
                }
                return null;
              }
            };
            break;
        }
      }

      return jsonFields;
    }
  }
};
</script>

<style scoped></style>
